import { computed, unref, type MaybeRef } from 'vue'

export function useDateString(date: MaybeRef<Date | string | null>) {
  const dateString = computed(() => {
    const dateVal = unref(date)
    if (dateVal === null) return ''

    const normalizedDateVal = new Date(dateVal)

    return normalizedDateVal.toLocaleDateString('en-US', { month: 'short', day: 'numeric' })
  })

  return dateString
}
